import React, { useEffect, useState } from 'react'
import { getTenantPlanView, loginAsTenantUser } from '../../store/actions/partnerAction';
import moment from "moment-timezone";
import { useDispatch, useSelector } from 'react-redux';
import { getWalletInfo } from '../../store/actions/tenantAction';
import { useTranslation } from 'react-i18next';

function ViewWaba({ setIsShow, waba }) {
    const { t } = useTranslation();
    const [account, setAccount] = useState({});
    const dispatch = useDispatch();
    const [isCopied, setIsCopied] = useState(false);
    const [walletInfo, setWalletInfo] = useState({});
    const partnerReducer = useSelector((state) => state.partnerReducer);
    const partnerTimezone =
        partnerReducer.partnerDetails?.timezone ??
        Intl.DateTimeFormat().resolvedOptions().timeZone

    useEffect(() => {
        dispatch(getTenantPlanView({
            criteria: { id: waba?.tenantId },
            filter: [],//[{ property: "tenantId", operator: "LT", value: waba?.tenantId }],
            count: false,
            size: 1,
            offset: 0
        }, (d) => {
            setAccount(Array.isArray(d?.data) ? d?.data[0] : {});
        }));
        dispatch(getWalletInfo(waba?.tenantId, { tenantWabaId: waba?.id }, setWalletInfo));
    }, []);

    const LoginAsUser = (customer) => {
        dispatch(loginAsTenantUser(customer, d => {
            localStorage.setItem("sessionToken", d?.access_token);
            localStorage.setItem("refreshToken", d?.refresh_token);
            window.location.replace(JSON.parse(process.env.REACT_APP_TENANT_PORTAL_CONFIG).redirect_uri);
        }));
    }

    const handleCopy = () => {
        navigator.clipboard
            .writeText(waba?.config?.apiKey ? waba?.config?.apiKey : waba?.accessToken)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 5000); // Reset after 2 seconds
            })
            .catch((error) => console.error("Copy failed", error));
    };
    return (
        <div className="h-[85vh] overflow-y-auto p-4">
            <div className="grid grid-cols-2 gap-3 w-full">
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Company Name</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.companyName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Team/WhatsApp Account Name </p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.teamName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Plan Activation Date</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{moment.utc(account?.tenantPlan?.fromDate)
                            .tz(partnerTimezone)
                            .format("YYYY-MM-DD hh:mm A") ?? "-"}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Plan Expiry Date</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{moment.utc(account?.tenantPlan?.toDate)
                            .tz(partnerTimezone)
                            .format("YYYY-MM-DD hh:mm A") ?? "-"}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Country</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.countryName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Currency Type</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.currencyCode}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Account Type</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.accountType}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Balance</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>
                            {walletInfo?.accountType === "POSTPAID" ? <label>
                                {t('Credit Limit')}
                                <span className="font-bold px-1">
                                    {walletInfo?.currencyCode}
                                    {" "}{(parseFloat(walletInfo?.availableWallet ?? 0) + parseFloat(walletInfo?.walletLimit ?? 0)).toFixed(2)}
                                </span>
                            </label> :
                                <label>
                                    {t('Wallet Balance')}
                                    <span className="font-bold pr-1">
                                        {walletInfo?.currencyCode}
                                        {" "}{walletInfo?.availableWallet}
                                    </span>
                                </label>}
                        </label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Plan Name</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{account?.tenantPlan?.planName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Rate Card Name</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{walletInfo?.rateCardName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Contact Person </p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{account?.contactPerson}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Contact Email</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{account?.contactEmail}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Contact No. </p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{`+${account?.contactPhoneCode} ${account?.contactPhone}`}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Status</p>
                    <div className=''>
                        {waba?.active ? (
                            <label className="bg-[#D4F8D3] px-[16px] pt-[4px] pb-[5px] rounded-full">
                                Active
                            </label>
                        ) : (
                            <label className="bg-[#F8F4D3] px-[16px] pt-[4px] pb-[6px] rounded-full">
                                Not Active
                            </label>
                        )}
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>WABA Phone Number</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>+{waba?.phoneCode + " " + waba?.phone}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Display Name</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.whatsappDisplayName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>WABA ID </p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.wabaNumber}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Time Zone </p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.timezone}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Verified Account</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <svg
                            className="mt-1 ml-1"
                            width="17"
                            height="18"
                            viewBox="0 0 17 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.95703 1.22715C8.12303 1.0571 8.3965 1.0571 8.56251 1.22715L9.40921 2.09452C9.53134 2.21963 9.71785 2.25673 9.87855 2.18788L10.9928 1.71055C11.2112 1.61697 11.4639 1.72162 11.5522 1.94226L12.0025 3.06763C12.0674 3.22995 12.2255 3.33559 12.4004 3.33349L13.6124 3.31887C13.85 3.31601 14.0434 3.50938 14.0405 3.74701L14.0259 4.95904C14.0238 5.13387 14.1295 5.29198 14.2918 5.35693L15.4171 5.80726C15.6378 5.89555 15.7424 6.1482 15.6489 6.36665L15.1715 7.48083C15.1027 7.64153 15.1398 7.82804 15.2649 7.95017L16.1323 8.79687C16.3023 8.96287 16.3023 9.23634 16.1323 9.40235L15.2649 10.249C15.1398 10.3712 15.1027 10.5577 15.1715 10.7184L15.6489 11.8326C15.7424 12.051 15.6378 12.3037 15.4172 12.392L14.2918 12.8423C14.1295 12.9072 14.0238 13.0653 14.0259 13.2402L14.0405 14.4522C14.0434 14.6898 13.85 14.8832 13.6124 14.8803L12.4004 14.8657C12.2255 14.8636 12.0674 14.9693 12.0025 15.1316L11.5522 16.2569C11.4639 16.4776 11.2112 16.5822 10.9928 16.4887L9.87855 16.0113C9.71785 15.9425 9.53134 15.9796 9.40921 16.1047L8.56251 16.9721C8.39651 17.1421 8.12304 17.1421 7.95703 16.9721L7.11033 16.1047C6.9882 15.9796 6.80169 15.9425 6.64099 16.0113L5.52681 16.4887C5.30836 16.5822 5.05571 16.4776 4.96742 16.257L4.51709 15.1316C4.45214 14.9693 4.29403 14.8636 4.1192 14.8657L2.90717 14.8803C2.66954 14.8832 2.47617 14.6898 2.47903 14.4522L2.49365 13.2402C2.49575 13.0653 2.39011 12.9072 2.22779 12.8423L1.10242 12.392C0.881778 12.3037 0.777125 12.051 0.87071 11.8326L1.34804 10.7184C1.41689 10.5577 1.37979 10.3712 1.25468 10.249L0.387308 9.40235C0.217252 9.23635 0.217251 8.96288 0.387308 8.79687L1.25468 7.95017C1.37979 7.82804 1.41689 7.64153 1.34804 7.48083L0.87071 6.36665C0.777125 6.1482 0.881778 5.89555 1.10242 5.80726L2.22779 5.35693C2.39011 5.29198 2.49575 5.13387 2.49365 4.95904L2.47903 3.74701C2.47617 3.50938 2.66954 3.31601 2.90717 3.31887L4.1192 3.33349C4.29403 3.33559 4.45214 3.22995 4.51709 3.06763L4.96742 1.94226C5.05571 1.72162 5.30836 1.61697 5.52681 1.71055L6.64099 2.18788C6.80169 2.25673 6.9882 2.21963 7.11033 2.09452L7.95703 1.22715Z"
                                fill={
                                    waba?.whatsappQualityRatings === "GREEN"
                                        ? "#1AE969"
                                        : "blue"
                                }
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.0755 6.53555C12.313 6.77305 12.313 7.15812 12.0755 7.39562L7.80917 11.6619C7.57167 11.8994 7.1866 11.8994 6.9491 11.6619L5.31583 10.0287C5.07832 9.79116 5.07832 9.40609 5.31583 9.16859C5.55333 8.93109 5.93839 8.93109 6.17589 9.16859L7.37914 10.3718L11.2154 6.53555C11.453 6.29805 11.838 6.29805 12.0755 6.53555Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>BSP</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.bspName}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Meta Account Status</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.whatsappVerificationStatus}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Quality Rating</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className='text-gray-900'>{waba?.whatsappQualityRatings}</label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>Messaging Limit</p>
                    <div className='bg-gray-100 py-1.5 px-2'>
                        <label className="text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]">
                            {waba?.messagingLimit}
                        </label>
                    </div>
                </div>
                <div className='text-[14px]'>
                    <p className='text-gray-500'>API Key: </p>
                    <div className='bg-gray-100 py-1.5 px-1 flex justify-between'>
                        <input type='text' readOnly className='text-gray-900 border-none py-1 w-full' value={waba?.config?.apiKey ? waba?.config?.apiKey : waba?.accessToken} />
                        <button type="button" className="bg-green-50 text-green-500 rounded-[4px]"
                            onClick={handleCopy}>
                            {isCopied ? "Copied" : "Copy"}
                        </button>
                    </div>
                </div>
                <div className='text-[14px] flex'>
                    <p className='text-gray-500'>Login as User</p>
                    <div className='px-2 pt-[-2px]'>
                        <button button="button" onClick={() => LoginAsUser({ id: waba.tenantId })} className='min-w-[76px] text-center px-[16px] py-[3px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary'>
                            Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewWaba